import './header.css';

const Header = () => {
    return (
        <div className="heading">
            <h1>Get weather in realtime !</h1>
        </div>
    )
}

export default Header;